// ROUTES
export const ROUTE_DASHBOARD = 'route/ROUTE_DASHBOARD'
export const ROUTE_NEWSLETTERS_EDIT = 'route/ROUTE_NEWSLETTERS_EDIT'
export const ROUTE_NEWSLETTERS_NEW = 'route/ROUTE_NEWSLETTERS_NEW'

export const ROUTE_COMPONENTS = 'route/ROUTE_COMPONENTS'
export const ROUTE_COMPONENTS_NEW = 'route/ROUTE_COMPONENTS_NEW'
export const ROUTE_COMPONENTS_EDIT = 'route/ROUTE_COMPONENTS_EDIT'

export const ROUTE_PRODUCTS = 'route/ROUTE_PRODUCTS'
export const ROUTE_PRODUCTS_NEW = 'route/ROUTE_PRODUCTS_NEW'
export const ROUTE_PRODUCTS_EDIT = 'route/ROUTE_PRODUCTS_EDIT'

export const ROUTE_USERS = 'route/ROUTE_USERS'
export const ROUTE_USERS_NEW = 'route/ROUTE_USERS_NEW'
export const ROUTE_USERS_EDIT = 'route/ROUTE_USERS_EDIT'

export const ROUTE_CONTACTS = 'route/ROUTE_CONTACTS'
export const ROUTE_CONTACTS_NEW = 'route/ROUTE_CONTACTS_NEW'
export const ROUTE_CONTACTS_EDIT = 'route/ROUTE_CONTACTS_EDIT'

export const ROUTE_LOGIN = 'route/ROUTE_LOGIN'
export const ROUTE_RESET = 'route/ROUTE_RESET'
export const ROUTE_REGISTER = 'route/ROUTE_REGISTER'



// WEBPACK FOOTER //
// ./state/types/routes.js